import { useMemo } from 'react';

import { SelectOption, Account } from '~/shared/utils/types';
import SidePanel from '~/shared/components/SidePanel';
import FilterPanelHeader from '~/shared/components/filters/FilterPanelHeader';

import { useFilterState } from './hooks';
import FilterPanelContent from './FilterPanelContent';

export type GroupFleetManagerSelectionOption = {
  label: string;
  options: SelectOption[];
};

interface AllVolumesFiltersSidePanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onResetFilters: () => void;
  appliedClusterNameFilters: SelectOption[];
  appliedInstanceFilters: SelectOption[];
  appliedVolumeIdFilters: SelectOption[];
  appliedVolumeTagFilters: SelectOption[];
  appliedAccountFilters: SelectOption[];
  appliedAutoscaleState: string[];
  isOrgView?: boolean;
  accounts?: Account[];
  activeOrgId?: string;
}

export default function AllVolumesFiltersSidePanel({
  open,
  onOpenChange,
  onResetFilters,
  appliedClusterNameFilters,
  appliedInstanceFilters,
  appliedVolumeIdFilters,
  appliedVolumeTagFilters,
  appliedAccountFilters,
  appliedAutoscaleState,
  isOrgView = false,
  accounts = [],
  activeOrgId,
}: AllVolumesFiltersSidePanelProps) {
  const filterState = useFilterState({
    open,
    appliedClusterNameFilters,
    appliedInstanceFilters,
    appliedVolumeIdFilters,
    appliedVolumeTagFilters,
    appliedAccountFilters,
    appliedAutoscaleState,
  });

  const hasActiveFilters =
    // appliedClusterNameFilters.length > 0 ||
    // appliedInstanceFilters.length > 0 ||
    // appliedVolumeIdFilters.length > 0 ||
    // appliedVolumeTagFilters.length > 0 ||
    // appliedAccountFilters.length > 0 ||
    // appliedAutoscaleState.length > 0 ||
    filterState.pendingClusterNameFilters.length > 0 ||
    filterState.pendingInstanceFilters.length > 0 ||
    filterState.pendingVolumeIdFilters.length > 0 ||
    filterState.pendingVolumeTagFilters.length > 0 ||
    filterState.pendingAccountFilters.length > 0 ||
    filterState.pendingAutoscaleState.length > 0;

  const handleClose = () => {
    filterState.applyPendingFilters();
  };

  const filterableAccounts = useMemo(() => {
    if (!activeOrgId) {
      return accounts;
    }
    return accounts.filter((account) => account.accountId !== activeOrgId);
  }, [accounts, activeOrgId]);

  const handleResetFilters = () => {
    filterState.resetPendingFilters();
    onResetFilters();
    onOpenChange(false);
  };

  // const handleApplyFilters = () => {
  //   applyFilters(
  //     filterState.pendingAutoscaleState,
  //     filterState.pendingClusterNameFilters,
  //     filterState.pendingVolumeIdFilters,
  //     filterState.pendingVolumeTagFilters,
  //     filterState.pendingAccountFilters,
  //     filterState.pendingInstanceFilters
  //   );
  // };

  return (
    <SidePanel open={open} onOpenChange={onOpenChange} width="w-[587px]" onClose={handleClose}>
      <div className="flex flex-col h-full">
        <FilterPanelHeader
          onClearAll={handleResetFilters}
          hasActiveFilters={hasActiveFilters}
          onClose={() => {
            handleClose();
            onOpenChange(false);
          }}
        />

        <FilterPanelContent
          panelOpen={open}
          pendingAutoscaleState={filterState.pendingAutoscaleState}
          setPendingAutoscaleState={filterState.setPendingAutoscaleState}
          pendingClusterNameFilters={filterState.pendingClusterNameFilters}
          setPendingClusterNameFilters={filterState.setPendingClusterNameFilters}
          pendingInstanceFilters={filterState.pendingInstanceFilters}
          setPendingInstanceFilters={filterState.setPendingInstanceFilters}
          pendingVolumeIdFilters={filterState.pendingVolumeIdFilters}
          setPendingVolumeIdFilters={filterState.setPendingVolumeIdFilters}
          pendingVolumeTagFilters={filterState.pendingVolumeTagFilters}
          setPendingVolumeTagFilters={filterState.setPendingVolumeTagFilters}
          pendingAccountFilters={filterState.pendingAccountFilters}
          setPendingAccountFilters={filterState.setPendingAccountFilters}
          isOrgView={isOrgView}
          accounts={filterableAccounts}
        />

        {/* <FilterActions
          onReset={handleResetFilters}
          onApply={handleApplyFilters}
          onClose={() => onOpenChange(false)}
          hasActiveFilters={
            filterState.pendingAutoscaleState.length > 0 ||
            filterState.pendingClusterNameFilters.length > 0 ||
            filterState.pendingVolumeIdFilters.length > 0 ||
            filterState.pendingVolumeTagFilters.length > 0 ||
            filterState.pendingAccountFilters.length > 0 ||
            filterState.pendingInstanceFilters.length > 0
          }
        /> */}
      </div>
    </SidePanel>
  );
}
